import { render, staticRenderFns } from "./CategoriesTree.vue?vue&type=template&id=6550b51c&scoped=true"
import script from "./CategoriesTree.vue?vue&type=script&lang=js"
export * from "./CategoriesTree.vue?vue&type=script&lang=js"
import style0 from "./CategoriesTree.vue?vue&type=style&index=0&id=6550b51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550b51c",
  null
  
)

export default component.exports